<div class="panel panel-flat">
  <div class="panel-heading">
    <h5 class="panel-title">
      <span>Report 16</span><span style="margin-left: 30px; font-weight: 500; font-size: 10px;" class="text-muted">20/06/2018 - 17-07-2018</span>
    </h5>

    <div class="heading-elements">
      <ul class="icons-list">
        <li><i class="icon-file-pdf"></i></li>
        <li><i class="icon-file-excel"></i></li>
        <li><a data-action="close"></a></li>
      </ul>
    </div>

  </div>

  <table class="table datatable-show-all">
    <thead>
    <tr>
      <th>Name of Industry</th>
      <th>Address of Industry</th>
      <th>District</th>
      <th>Average Close Time</th>
      <th>No of Interval of Close/Non-operation CEMS</th>
      <th>Name of Parameter Displayed by Industry</th>
      <th class="text-center">Detail Status</th>
    </tr>
    </thead>
    <tbody>
    <tr>
      <td>Marth</td>
      <td><a href="#">Enright</a></td>
      <td>Traffic Court Referee</td>
      <td>test Xyz</td>
      <td>test Xyz</td>
      <td><span class="label label-success">Active</span></td>
      <td class="text-center">
        <ul class="icons-list">
          <li class="dropdown">
            <a href="#" class="dropdown-toggle" data-toggle="dropdown">
              <i class="icon-menu9"></i>
            </a>

            <ul class="dropdown-menu dropdown-menu-right">
              <li><a href="#"><i class="icon-file-pdf"></i> Export to .pdf</a></li>
              <li><a href="#"><i class="icon-file-excel"></i> Export to .csv</a></li>
              <li><a href="#"><i class="icon-file-word"></i> Export to .doc</a></li>
            </ul>
          </li>
        </ul>
      </td>
    </tr>
    <tr>
      <td>Marth</td>
      <td><a href="#">Enright</a></td>
      <td>Traffic Court Referee</td>
      <td>test Xyz</td>
      <td>test Xyz</td>
      <td><span class="label label-success">Active</span></td>
      <td class="text-center">
        <ul class="icons-list">
          <li class="dropdown">
            <a href="#" class="dropdown-toggle" data-toggle="dropdown">
              <i class="icon-menu9"></i>
            </a>

            <ul class="dropdown-menu dropdown-menu-right">
              <li><a href="#"><i class="icon-file-pdf"></i> Export to .pdf</a></li>
              <li><a href="#"><i class="icon-file-excel"></i> Export to .csv</a></li>
              <li><a href="#"><i class="icon-file-word"></i> Export to .doc</a></li>
            </ul>
          </li>
        </ul>
      </td>
    </tr>
    <tr>
      <td>Marth</td>
      <td><a href="#">Enright</a></td>
      <td>Traffic Court Referee</td>
      <td>test Xyz</td>
      <td>test Xyz</td>
      <td><span class="label label-success">Active</span></td>
      <td class="text-center">
        <ul class="icons-list">
          <li class="dropdown">
            <a href="#" class="dropdown-toggle" data-toggle="dropdown">
              <i class="icon-menu9"></i>
            </a>

            <ul class="dropdown-menu dropdown-menu-right">
              <li><a href="#"><i class="icon-file-pdf"></i> Export to .pdf</a></li>
              <li><a href="#"><i class="icon-file-excel"></i> Export to .csv</a></li>
              <li><a href="#"><i class="icon-file-word"></i> Export to .doc</a></li>
            </ul>
          </li>
        </ul>
      </td>
    </tr>
    <tr>
      <td>Marth</td>
      <td><a href="#">Enright</a></td>
      <td>Traffic Court Referee</td>
      <td>test Xyz</td>
      <td>test Xyz</td>
      <td><span class="label label-success">Active</span></td>
      <td class="text-center">
        <ul class="icons-list">
          <li class="dropdown">
            <a href="#" class="dropdown-toggle" data-toggle="dropdown">
              <i class="icon-menu9"></i>
            </a>

            <ul class="dropdown-menu dropdown-menu-right">
              <li><a href="#"><i class="icon-file-pdf"></i> Export to .pdf</a></li>
              <li><a href="#"><i class="icon-file-excel"></i> Export to .csv</a></li>
              <li><a href="#"><i class="icon-file-word"></i> Export to .doc</a></li>
            </ul>
          </li>
        </ul>
      </td>
    </tr>
    <tr>
      <td>Marth</td>
      <td><a href="#">Enright</a></td>
      <td>Traffic Court Referee</td>
      <td>test Xyz</td>
      <td>test Xyz</td>
      <td><span class="label label-success">Active</span></td>
      <td class="text-center">
        <ul class="icons-list">
          <li class="dropdown">
            <a href="#" class="dropdown-toggle" data-toggle="dropdown">
              <i class="icon-menu9"></i>
            </a>

            <ul class="dropdown-menu dropdown-menu-right">
              <li><a href="#"><i class="icon-file-pdf"></i> Export to .pdf</a></li>
              <li><a href="#"><i class="icon-file-excel"></i> Export to .csv</a></li>
              <li><a href="#"><i class="icon-file-word"></i> Export to .doc</a></li>
            </ul>
          </li>
        </ul>
      </td>
    </tr>

    </tbody>
  </table>
</div>